/**
 * Created by Jerker Nord on 2024-02-23.
 */
import {LonerSymbol} from "../LonerSymbol";
import {LonerSymbolStates, SYMBOL_NAMES} from "../../../../../core/reel/ReelInterfaces";
import {LonerStatics} from "../../../../LonerStatics";

export class LonerBigWildSymbol extends LonerSymbol{

    protected _bigSymContainer:PIXI.Container;
    protected _bigSymbolSplitContainer:PIXI.Container;

    constructor() {
        super();
        this._bigSymContainer = new PIXI.Container();
        this.addChild(this._bigSymContainer);
        this._bigSymbolSplitContainer = new PIXI.Container();
        this.addChild(this._bigSymbolSplitContainer);
        this.addChild(this._darkOverlay);
        this._bigSymContainer.addChild(this._newStateSprite);
        this._bigSymContainer.addChild(this._currentStateSprite);
    }
}